import styled from 'styled-components';

export const ModalCloseButton = styled.button.attrs(() => ({
  className: `f3 outline-0 pointer bn pa0 ma0 br-100 bn w2 h2 flex-shrink-0 flex items-center justify-center`,
}))``;
